import { Anchor } from '@components/Anchor';
import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import { IMenu } from '@hooks/useMenu';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IVendedor, useVendedorStatusColor } from '@model/Vendedor';
import { IVendedorFilter } from '@services/VendedorService';
import React from 'react';

export type VendedorTableProps = {
    data: IData<IVendedor, IVendedorFilter>
    isLoading: boolean
    menu: IMenu
}

export function VendedorTable ({ data, isLoading, menu }: VendedorTableProps) {
    const vendedorStatusColor = useVendedorStatusColor();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="vendedorId">ID</TableSortCell>
                        <TableSortCell fieldName="nome">Nome</TableSortCell>
                        <TableSortCell fieldName="cpf">CPF</TableSortCell>
                        <TableSortCell fieldName="telefone">Telefone</TableSortCell>
                        <TableSortCell fieldName="status">Status</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((vendedor, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell><Anchor href={`/vendedor/${vendedor.vendedorId}`}>{vendedor.vendedorId}</Anchor></TableKeyCell>
                                    <TableCell>{vendedor.nome}</TableCell>
                                    <TableCell>{vendedor.cpf}</TableCell>
                                    <TableCell>{vendedor.telefone}</TableCell>
                                    <TableCell className={vendedorStatusColor[vendedor.status]}>{vendedor.statusDescription}</TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(vendedor, menu.open)} />
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>
        </TableWrapper>
    )
}